// extracted by mini-css-extract-plugin
export default {"wrapper":"DiscountInputField_wrapper__WrTHo","title":"DiscountInputField_title__gbV-x","fields":"DiscountInputField_fields__6J2ET"};